import React, { useCallback } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Tab } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { StyledTabPane, StyledTabWrapper } from '../style'

interface BasePriceTextProps {
  languages: any[]
}

const BasePriceText: React.FC<BasePriceTextProps> = (props) => {
  const { control } = useFormContext()
  const { t } = useTranslation()
  const { fields } = useFieldArray({
    control,
    name: 'texts[0].languages',
    keyName: 'key'
  })

  const renderLanguageTab = useCallback((lan, index) => {
    const languages = fields || []
    const indexLanguage = languages.findIndex(language => language['id'] === lan.id)
    return <StyledTabPane key={fields[indexLanguage].key}>
      <FormFields.Input
        control={control}
        width={8}
        placeholder={t('Enter base price')}
        label={t('Base price')}
        name={`texts[0].languages[${indexLanguage}].translation`}
        rules={{
          required: {
            value: true,
            message: t('Please enter base price')
          }
        }}
      />
    </StyledTabPane>
  }, [])

  function renderLanguageTabs() {
    const panes = []
    props.languages.map((language, index) => {
      panes.push({
        menuItem: language['label'],
        render: () => renderLanguageTab(language, index)
      })
    })
    return <Tab
      menu={{ secondary: true, pointing: true }}
      panes={panes}
    />
  }

  return <StyledTabWrapper>
    {renderLanguageTabs()}
  </StyledTabWrapper>
}
export default BasePriceText